'use client';
import { OrVideoHero } from '@/components/organisms/or-video-hero/or-video-hero';
import { IOrVideoHeroProps } from './or-video-hero.types';

export const ClientVideoHero = (props: IOrVideoHeroProps) => (
  <OrVideoHero {...props} />
);
